/**
 * 电力运维
 */
const electricOperations = {
  listElectricOperationsWorkBases: '/api/listElectricOperationsWorkBases',
  addElectricOperationsWorkBase: '/api/addElectricOperationsWorkBase',
  deleteElectricOperationsWorkBase: '/api/deleteElectricOperationsWorkBase',
  modifyElectricOperationsWorkBase: '/api/modifyElectricOperationsWorkBase',
  addElectricOperationsWorkBaseMembers:
    '/api/addElectricOperationsWorkBaseMembers',
  removeElectricOperationsWorkBaseMembers:
    '/api/removeElectricOperationsWorkBaseMembers',
  listElectricOperationsWorkBaseMembers:
    '/api/listElectricOperationsWorkBaseMembers',
  listElectricOperationsWorkOrdersForServiceProvider:
    '/api/listElectricOperationsWorkOrdersForServiceProvider',
  // listElectricOperationsWorkOrdersForClient: "/api/listElectricOperationsWorkOrdersForClient",
  scoreElectricOperationsWorkOrder: '/api/scoreElectricOperationsWorkOrder',

  listClientsForElectricOperationsCompany:
    '/api/listClientsForElectricOperationsCompany',
  listElectricOperationsCompaniesForClient:
    '/api/listElectricOperationsCompaniesForClient',
  // 合同
  listElectricOperationsContractForServiceProvider:
    '/api/listElectricOperationsContractForServiceProvider',
  // 计划
  listElectricOperationsPlansInPage: '/api/listElectricOperationsPlansInPage',
  listElectricOperationsPlans: '/api/listElectricOperationsPlans',
  addElectricOperationsPlanByContractServiceItem:
    '/api/addElectricOperationsPlanByContractServiceItem',
  addElectricOperationsPlan: '/api/addElectricOperationsPlan',
  cancelElectricOperationsPlan: '/api/cancelElectricOperationsPlan',
  modifyElectricOperationsPlan: '/api/modifyElectricOperationsPlan',
  listElectricOperationsWorkOrdersForClient:
    '/api/listElectricOperationsWorkOrdersForClient',
  // 工单
  getElectricOperationsContractInfo: '/api/getElectricOperationsContractInfo',
  listElectricOperationsWorkOrdersForServiceProviderInPage:
    '/api/listElectricOperationsWorkOrdersForServiceProviderInPage',
  listElectricOperationsWorkOrdersByPlanInPage:
    '/api/listElectricOperationsWorkOrdersByPlanInPage',
  addElectricOperationsWorkOrder: '/api/addElectricOperationsWorkOrder',
  listElectricOperationsWorkOrderDispatchingPriorityRegulation:
    '/api/listElectricOperationsWorkOrderDispatchingPriorityRegulation',
  changeElectricOperationsWorkOrderState:
    '/api/changeElectricOperationsWorkOrderState',
  setElectricOperationsWorkOrderToWorkBase:
    '/api/setElectricOperationsWorkOrderToWorkBase',
  setElectricOperationsWorkOrderExecutor:
    '/api/setElectricOperationsWorkOrderExecutor',
  getElectricOperationsWorkOrderReportData:
    '/api/getElectricOperationsWorkOrderReportData',
  lookupElectricOperationsWorkOrderDataDict:
    '/api/lookupElectricOperationsWorkOrderDataDict',
  getOperationsMeasureInfo: '/api/getOperationsMeasureInfo',
  getEquipmentMaintenanceHistory: '/api/getEquipmentMaintenanceHistory',
  listManageWorkBaseInfo: '/api/listManageWorkBaseInfo',
  listElectricOperationsPlansByWorkOrder:
    '/api/listElectricOperationsPlansByWorkOrder',
  listElectricOperationsWorkOrderStateChangingHistory:
    '/api/listElectricOperationsWorkOrderStateChangingHistory',

  // 知识库
  getKnowledgeBase: '/api/getKnowledgeBase',
  addKnowledgeBase: '/api/addKnowledgeBase',
  deleteKnowledgeBase: '/api/deleteKnowledgeBase',
  updateKnowledgeBase: '/api/updateKnowledgeBase',

  getMOViewTreeNodes: '/api/getMOViewTreeNodes',
  getElectricOperationsWorkOrder: '/api/getElectricOperationsWorkOrder',
  listProjectVOInfoForClient: '/api/listProjectVOInfoForClient',
  getProjectVOListByProjectId: '/api/getProjectVOListByProjectId',
  listWorkOrderPlanInfoInPage: '/api/listWorkOrderPlanInfoInPage',

  listElectricOperationsWorkOrdersByPlan:
    '/api/listElectricOperationsWorkOrdersByPlan',
}

export default electricOperations
